import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import tempTrailerBg from '../assets/tempTrailerBg.jpg';
import tempTrailerBgM from '../assets/tempTrailerBgM.jpg';
import playIcon from '../assets/playButton.svg';
import closeIcon from '../assets/closeIcon.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    height: '100vh',
    marginTop: '400%',
    position: 'relative',
    backgroundImage: `url(${tempTrailerBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.up('xl')]: {
      marginTop: '400%'
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: '500%'
    },
    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${tempTrailerBgM})`,
      marginTop: '600%'
    },
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${tempTrailerBgM})`,
      marginTop: '800%'
    },
    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${tempTrailerBgM})`,
      marginTop: '1400%'
    }
  },
  img: {
    width: '100%',
    height: '100%'
  },
  buttonCont: {
    position: 'absolute',
    bottom: '3.5rem',
    left: '50%',
    marginLeft: '-6rem',
    [theme.breakpoints.down('md')]: {
      marginLeft: '-8.5rem'
    }
  },
  playTrailerButton: {
    color: '#fff',
    width: '12rem',
    border: '1px solid #fff',
    fontFamily: 'neuePlakB',
    fontSize: '.875rem',
    letterSpacing: '3px',
    borderRadius: 0,
    padding: '1rem',
    backgroundColor: theme.palette.common.ghostButton,
    [theme.breakpoints.down('md')]: {
      width: '17rem'
    }
  },
  videoModalCont: {
    width: '100%',
    height: '100vh',
    zIndex: 11,
    position: 'fixed',
    display: 'none',
    right: 0,
    top: 0,
    backgroundColor: '#000'
  },
  closeButtonCont: {
    position: 'absolute',
    top: '4rem',
    right: '2rem',
    width: '6rem',
    height: '6rem',
    [theme.breakpoints.down('md')]: {
      right: '2rem'
    },
    [theme.breakpoints.down('sm')]: {
      right: '1rem',
      top: '4rem'
    }
  },
  videoCont: {
    width: '100%',
    height: '100%'
  },
  video: {
    width: '85%'
  }
}));

const Trailer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [isOpen, setOpen] = useState(false);
  const { ref, inView } = useInView({ threshold: 0.05 });

  const toggleModal = () => {
    const drawer = document.getElementById('trailerModal');
    if (!isOpen) {
      drawer.style.display = 'block';
      setOpen(true);
    } else {
      drawer.style.display = 'none';
      setOpen(false);
    }
  };

  return (
    <Grid
      id="trailer"
      container
      justifyContent={matchesSM ? 'center' : undefined}
      className={classes.wrapper}
    >
      <Grid container justifyContent="center" alignItems="center" className={classes.modalCont}>
        <Grid ref={ref} id="trailerModal" container className={classes.videoModalCont}>
          <Grid item className={classes.closeButtonCont}>
            <Button
              onClick={() => toggleModal()}
              className={classes.closeButton}
              style={{ width: '100%' }}
            >
              <img src={closeIcon} alt="x" style={{ width: '100%' }} />
            </Button>
          </Grid>
          {inView ? (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              className={classes.videoCont}
            >
              <Grid container justifyContent="center" alignItems="center" className={classes.video}>
                <Grid item style={{ width: '100%' }}>
                  <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                    <iframe
                      src="https://player.vimeo.com/video/680613465?h=07bed852e7&amp;badge=0&amp;autoplay=1&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameBorder="0"
                      allow="autoplay"
                      allowFullScreen
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                      }}
                      title="Gilead Blind Angels Trailer"
                    ></iframe>
                  </div>
                  <script src="https://player.vimeo.com/api/player.js"></script>
                </Grid>
              </Grid>
            </Grid>
          ) : undefined}
        </Grid>
        <Grid item className={classes.buttonCont}>
          <Button className={classes.playTrailerButton} onClick={() => toggleModal()}>
            <img src={playIcon} alt="play triangle icon" style={{ marginRight: '1rem' }} />
            PLAY TRAILER
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Trailer;
